import { render } from "./LbrxLanguageSelectPopup.vue?vue&type=template&id=b98ccfb8&scoped=true"
import script from "./LbrxLanguageSelectPopup.vue?vue&type=script&lang=js"
export * from "./LbrxLanguageSelectPopup.vue?vue&type=script&lang=js"

import "./LbrxLanguageSelectPopup.vue?vue&type=style&index=0&id=b98ccfb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b98ccfb8"]])

export default __exports__